<template>
    <div class="text-left sticky mt-16 md:mt-0 flex-auto px-3 md:px-0 pr-3 md:pr-12 lg:pr-24 top-32 h-min">
        <div class="flex-auto md:w-auto flex flex-col items-center">
            <div class="flex flex-col w-full">
                <div class="flex flex-col w-full p-6 rounded-md bg-white" style="box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);">
                    <p class="text-md">Themenwelt</p>
                    <div class="w-full h-1 bg-gray-300 rounded-md mt-3"></div>
                    <div class="flex flex-col gap-2 mt-5">
                        <button
                            class="text-sm hover:underline hover:pl-1 py-1 duration-200 flex w-full gap-2 items-center group"
                            v-for="i in gridNav" :key="i" @click="$router.push(i.link)">

                            {{ i.name }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "",
    data() {
        return {
            gridNav: [
                {
                    name: "Gottesdienst",
                    link: "/themenwelt/gottesdienst"
                },
                // {
                //     name: "Krabbelgruppe",
                //     link: "/themenwelt/krabbelgruppe"
                // },
                {
                    name: "Pfadfinder",
                    link: "/themenwelt/pfadfinder"
                },
                {
                    name: "Jugendliche",
                    link: "/themenwelt/jugendliche"
                },
                {
                    name: "Gemeindenachmittag",
                    link: "/themenwelt/gemeindenachmittag"
                },
                {
                    name: "Frauenkreis",
                    link: "/themenwelt/frauenkreis"
                },
            ]
        }
    },
}
</script>